import React, {Component} from 'react'
import * as colors from '../colors'
import {style, media, merge} from 'glamor'

export default class Panel extends Component {

  render(){
    const {children, color=colors.yellow, ...props} = this.props
    return (
      <div
        {...props}
        {...merge(
          style({
            padding: '1.5rem 1.5rem',
            border: `3px solid ${color}`
          }),
          media('(min-width: 800px)', {
            padding: '1rem 2rem',

          }),
          media('(min-width: 1000px)', {
            padding: '3rem 4rem',
          })
        )}
      >
        {children}
      </div>
    )
  }

}



/** WEBPACK FOOTER **
 ** ./src/components/Panel.js
 **/